import { Selector } from '@ngxs/store';
import { ExploreStateModel } from '../models/explore-state.model';
import { ExploreState } from './explore.state';

export class ExploreSelectors {
  @Selector([ExploreState])
  static marines(state: ExploreStateModel) {
    return state.marines;
  }

  @Selector([ExploreState])
  static groups(state: ExploreStateModel) {
    return state.groups;
  }

  @Selector([ExploreState])
  static plans(state: ExploreStateModel) {
    return state.plans;
  }

  @Selector([ExploreState])
  static loading(state: ExploreStateModel) {
    return state.loading;
  }

  @Selector([ExploreState])
  static loadingTrainingLoads(state: ExploreStateModel) {
    return state.loadingTrainingLoads;
  }

  @Selector([ExploreState])
  static loadingAnalyses(state: ExploreStateModel) {
    return state.loadingAnalyses;
  }

  @Selector([ExploreState])
  static loadingPftScores(state: ExploreStateModel) {
    return state.loadingPftScores;
  }

  @Selector([ExploreState])
  static loadingCftScores(state: ExploreStateModel) {
    return state.loadingPftScores;
  }

  @Selector([ExploreState])
  static groupTrainingLoads(state: ExploreStateModel) {
    return state.groupTrainingLoads;
  }

  @Selector([ExploreState])
  static individualTrainingLoads(state: ExploreStateModel) {
    return state.individualTrainingLoads;
  }

  @Selector([ExploreState])
  static individualTrainingLoadAnalyses(state: ExploreStateModel) {
    return state.individualTrainingLoadAnalyses;
  }

  @Selector([ExploreState])
  static planTrainingLoads(state: ExploreStateModel) {
    return state.planTrainingLoads;
  }

  @Selector([ExploreState])
  static planTrainingLoadAnalyses(state: ExploreStateModel) {
    return state.planTrainingLoadAnalyses;
  }

  @Selector([ExploreState])
  static groupTrainingLoadAnalyses(state: ExploreStateModel) {
    return state.groupTrainingLoadAnalyses;
  }

  @Selector([ExploreState])
  static weeks(state: ExploreStateModel) {
    return state.weeks;
  }

  @Selector([ExploreState])
  static selectedMarine(state: ExploreStateModel) {
    return state.selectedMarine;
  }

  @Selector([ExploreState])
  static selectedPlan(state: ExploreStateModel) {
    return state.selectedPlan;
  }

  @Selector([ExploreState])
  static selectedGroup(state: ExploreStateModel) {
    return state.selectedGroup;
  }

  @Selector([ExploreState])
  static selectedGroupPlans(state: ExploreStateModel) {
    return state.selectedGroupPlans;
  }

  @Selector([ExploreState])
  static tabState(state: ExploreStateModel) {
    return state.tabState;
  }

  @Selector([ExploreState])
  static trainingLoadParams(state: ExploreStateModel) {
    return state.trainingLoadParams;
  }

  @Selector([ExploreState])
  static individualPftScoreDocuments(state: ExploreStateModel) {
    return state.individualPftScoreDocuments;
  }

  @Selector([ExploreState])
  static individualCftScoreDocuments(state: ExploreStateModel) {
    return state.individualCftScoreDocuments;
  }

  @Selector([ExploreState])
  static groupPftScoreDocuments(state: ExploreStateModel) {
    return state.groupPftScoreDocuments;
  }

  @Selector([ExploreState])
  static groupCftScoreDocuments(state: ExploreStateModel) {
    return state.groupCftScoreDocuments;
  }
}
